import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { topConfig } from './config';
import { detailFn } from 'api/tool/message';
export default {
  data: function data() {
    return {
      visible: false,
      info: {},
      topConfig: topConfig(this)
    };
  },
  methods: {
    init: function init(item) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.visible = true;
              _this.getMsgInfo(item);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getMsgInfo: function getMsgInfo(item) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return detailFn({
                id: item.id
              });
            case 2:
              res = _context2.sent;
              if (res && res.code === 1) _this2.info = res.data;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};